import { Link } from 'react-router-dom';

export default function CommunityCategories() {
  return null;
}
